import { useEffect, useState } from 'react';
import { InfoTooltipPropsModel } from './info-tooltip-props.model';
import { usePopper } from 'react-popper';
import './info-tooltip.css';
import TooltipIcon from './Tooltip-icon';

const InfoTooltip = ({
  children,
  content,
  isTooltipIconVisible,
  isTooltipVisible,
  preventOverflow: propsPreventOverflow,
  tooltipClassname,
  tooltipIconClassName,
  tooltipPopupClassname,
  tooltipStyle,
  placement,
}: InfoTooltipPropsModel) => {
  const tooltipClassnameProp = tooltipClassname || '';
  const tooltipIconClassnameProp = tooltipIconClassName || '';
  const tooltipPopupClassnameProp = tooltipPopupClassname || '';

  const [isVisible, setIsVisible] = useState(false);
  const [referenceElement, setReferenceElement] =
    useState<HTMLDivElement | null>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
    null
  );
  const [arrowElement, setArrowElement] = useState<HTMLDivElement | null>(null);

  const preventOverflow = propsPreventOverflow
    ? [
        {
          name: 'preventOverflow',
          options: {
            altAxis: true,
            padding: 16,
          },
        },
      ]
    : [];

  const { styles, attributes, update } = usePopper(
    referenceElement,
    popperElement,
    {
      ...(placement && { placement }),
      modifiers: [
        {
          name: 'arrow',
          options: {
            element: arrowElement,
          },
        },
        {
          name: 'offset',
          options: {
            offset: [0, 16],
          },
        },
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['top', 'right', 'bottom', 'left'],
          },
        },
        ...preventOverflow,
      ],
    }
  );

  useEffect(() => {
    if (update) {
      setIsVisible(isTooltipVisible || false);
      update();
    }
  }, [update, isTooltipVisible]);

  const setPopperVisibility = (visibility) => {
    if (isTooltipVisible) {
      return;
    }

    if (update) {
      setIsVisible(visibility);
      update();
    }
  };

  return (
    <div
      className={`
        font-medium
        ${tooltipClassnameProp}
        ${isVisible ? 'z-90' : ''}
        ${isTooltipIconVisible ? 'block' : 'hidden'}
      `}
    >
      {children ? (
        <div
          className={`flex ${tooltipIconClassnameProp}`}
          onMouseEnter={() => setPopperVisibility(true)}
          onMouseLeave={() => setPopperVisibility(false)}
          ref={setReferenceElement}
        >
          {children}
        </div>
      ) : (
        <TooltipIcon
          tooltipIconClassname={`text-grey-30 hover:text-black ${tooltipIconClassnameProp}`}
          onMouseEnter={() => setPopperVisibility(true)}
          onMouseLeave={() => setPopperVisibility(false)}
          popperRef={setReferenceElement}
        />
      )}
      <div
        id="tooltip"
        className={`
          relative
          ${tooltipPopupClassnameProp}
          min-w-xs
          rounded-4xl
          p-5
          ${
            tooltipStyle === 'light'
              ? 'bg-white border border-grey-30 shadow-md'
              : 'bg-grey-80'
          }
          text-white
          dark:bg-grey-70
          ${isVisible ? 'block' : 'hidden'}
          z-100
        `}
        ref={setPopperElement}
        style={styles.popper}
        {...attributes.popper}
      >
        {tooltipStyle !== 'light' && (
          <div id="arrow" ref={setArrowElement} style={styles.arrow} />
        )}
        {content}
      </div>
    </div>
  );
};

export default InfoTooltip;
